import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DOCUMENT_CLASSIFICATIONS } from "@Shared/utils/constants";
import TimelineCard from "./utils/timeline-card.vue";
import { openFileDialog } from "@Shared/utils/utils";
import { mapActions } from "vuex";
import { DOWNLOAD_DOCUMENT } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineFile",
  components: {
    TimelineCard,
    InlineLoader
  },
  props: {
    classificationType: {
      type: String,
      default: ""
    },
    applicationId: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    numOfComments: {
      type: Number,
      default: 0
    },
    createdAt: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    details: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT])), {}, {
    getClassification(type) {
      return DOCUMENT_CLASSIFICATIONS[type] || type;
    },
    async downloadDocument() {
      if (this.loading) return;
      this.loading = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername: this.details.linkedAccountUsername,
        applicationId: this.applicationId,
        fileName: this.name,
        documentId: this.id
      });
      openFileDialog(url, this.fileName);
      this.loading = false;
    }
  })
});